import { CategoryButton } from "@/components/atoms/modernise-with-ai/CategoryButton";
import { modernizationTools } from "@/data/modernizationTools";

interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategory,
  onCategoryChange,
}) => (
  <div className="mb-6">
    <h2 className="text-lg font-semibold mb-3">Modernization Tools</h2>
    <div className="flex flex-wrap gap-2">
      {categories.map((category) => (
        <CategoryButton
          key={category}
          label={category}
          isActive={selectedCategory === category}
          count={
            category !== "All"
              ? modernizationTools.filter((t) => t.category === category).length
              : undefined
          }
          onClick={() => onCategoryChange(category)}
        />
      ))}
    </div>
  </div>
);
